
<section>
  <kendo-grid [data]="finishSampleGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="finishSampleGridstate.sort"
              (sortChange)="finishSampleGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="finishSampleGridstate.take"
              [skip]="finishSampleGridstate.skip"
              [columnMenu]="false"
              (pageChange)="finishSampleGridPageChange($event)"
              (dataStateChange)="finishSampleDataStateChange($event)"
              [filter]="finishSampleGridstate.filter"
              [loading]="finishSampleLoading"
              id="sample-product-admin-grid">

    <kendo-grid-column field="categoryName" title="{{finishSampleLbl.categoryName}}" [headerClass]="'wrapheader-sample-admin-grid'"
                       [width]="160" [columnMenu]="false" [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="sample-grid-category-div">
          <span>
            <button kendoButton class="clearKendoButton btn btn-success btnSizeCls btn-edit-category-noborder"
                    (click)="editSampleCategory(dataItem)">
              <span class="k-icon k-i-edit k-i-pencil"></span>
            </button>
          </span>
          <span>{{dataItem.categoryName}}</span>
        </div>
      </ng-template>

      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="subCategoryDescription" title="{{finishSampleLbl.subCategoryDescription}}"
                       [headerClass]="'wrapheader-sample-admin-grid'" [width]="180" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="colorCode" title="{{finishSampleLbl.colorCode}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="80" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="maxQtyCanBeOrdered" title="{{finishSampleLbl.maxQtyCanBeOrdered}}" [width]="90" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.subCategoryId; else noListItemQty">
          <span *ngIf="dataItem.maxQtyCanBeOrdered == 99999"></span>
          <span *ngIf="dataItem.maxQtyCanBeOrdered != 99999">{{dataItem.maxQtyCanBeOrdered}}</span>
        </ng-container>
        <ng-template #noListItemQty>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="stockNum" title="{{finishSampleLbl.stockNum}}" [width]="90" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.subCategoryId; else noListItemStock">
          <span>{{dataItem.stockNum}}</span>
        </ng-container>
        <ng-template #noListItemStock>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="currentCostId" title="{{finishSampleLbl.currentCostId}}" [width]="80" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.subCategoryId; else noListItemCost">
          <span>{{dataItem.currentCostId|currency}}</span>
        </ng-container>
        <ng-template #noListItemCost>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="currentInventory" title="{{finishSampleLbl.currentInventory}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="90" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.subCategoryId; else noListItemInventory">
          <span>{{dataItem.currentInventory}}</span>
        </ng-container>
        <ng-template #noListItemInventory>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="reorderPoint" title="{{finishSampleLbl.reorderPoint}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="90" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.subCategoryId; else noListItemReorder">
          <span>{{dataItem.reorderPoint}}</span>
        </ng-container>
        <ng-template #noListItemReorder>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="ec" title="{{finishSampleLbl.ec}}" [columnMenu]="false" [width]="90"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{finishSampleLbl.onBackOrder}}" field="onBackOrder" [width]="90" [headerClass]="'wrapheader-sample-admin-grid'" filter="boolean">
      <kendo-grid-messages filterIsTrue="Yes"
                           filterIsFalse="No">
      </kendo-grid-messages>
      <ng-template kendoGridCellTemplate let-dataItem >
        <div *ngIf="dataItem.subCategoryId">
          <kendo-switch [(ngModel)]="dataItem.onBackOrder" [onLabel]="'Yes'" [disabled]="true"
                        [offLabel]="'No'">
          </kendo-switch>
        </div>        
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{finishSampleLbl.isActive}}" field="isActive" [width]="90" filter="boolean">
      <kendo-grid-messages filterIsTrue="Yes"
                           filterIsFalse="No">
      </kendo-grid-messages>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.subCategoryId">
          <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'" [disabled]="true"
                        [offLabel]="'No'">
          </kendo-switch>
        </div>        
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="{{finishSampleLbl.action}}" [width]="155" field="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.subCategoryId">
          <button kendoButton class="clearKendoButton btn btn-success btnSizeCls btn-sample-admin-grid-edit"
                  (click)="editFinishSample(dataItem)">
            <span class=" k-icon k-i-edit k-i-pencil"></span>
          </button>
          <button class="k-button k-grid-remove-command btn-sample-admin-grid-edit" (click)="editFinishCopySample(dataItem)">
            <span class="k-icon k-i-copy">
            </span>
          </button>
          <button class="k-button k-grid-remove-command btn-sample-admin-grid-edit" (click)="removeConfirmation(dataItem)">
            <span class="k-icon k-i-trash">
            </span>
          </button>
          <br>
        </div>
        
      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
  </kendo-grid>
  <!--Sample Product Fullfilment-->
  <div class="col-sm-12">
    <div class="col-sm-12 center">
      <button (click)="togglefinishCategoryDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
        Add New Category
      </button>
      <button (click)="toggleFinishSampleDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
        Add New Product
      </button>
      <button class="m-3 btn btn-success" [routerLink]="['sample-request-admin/sample-request-inventory-usage-report']"
              kendoButton (click)="redirectToInventoryUsagePage()">
        Inventory/Usage Reports
      </button>
      <button class="m-3 btn btn-success" [routerLink]="['sample-request-admin/admin-budget-report']"
              kendoButton (click)="redirectToBudgetAllocationPage()" >
        Budget Allocations/Reports
      </button>
      <button class="m-3 btn btn-success" [routerLink]="['sample-request-admin/sample-request-order-history']"
              kendoButton (click)="redirectToOrderHistoryPage()">
        Order History
      </button>
    </div>
  </div>

</section>

<!--Sample Product Fullfilment-->
<section class="dialogSection">
  <kendo-dialog [title]="sampleSubCategoryTitleText" *ngIf="finishSampleDialog.opened" (close)="toggleFinishSampleDialog()">
    <form [formGroup]="finishSampleForm" style="max-height: 450px">

      <div class="row">
        <input type="hidden" formControlName="subCategoryId" />
        <div class="col-sm-12">
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.categoryName}}<span class="requiredField">*</span>
            </label>

            <kendo-dropdownlist class="kendoInput" formControlName="category" [ngModel]="{categoryName:selectedCategory,categoryId:selectedCategoryId}"
                                [data]="categoryData"
                                textField="categoryName" valueField="categoryId"
                                [ngClass]="{'borderRed':finishSampleLbl.isEmptyCategory && finishSampleLbl.isSubmitted}"
                                (blur)="validateSubCategoryForm()" (selectionChange)="categoryChange($event)">
            </kendo-dropdownlist>
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.subCategoryDescription}}<span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox formControlName="subCategory" class="kendoInput"
                   [ngClass]="{'borderRed':finishSampleLbl.isEmptySubCategory && finishSampleLbl.isSubmitted}"
                   (blur)="validateSubCategoryForm()" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.ec}}
            </label><br />
            <input type="text" kendoTextBox formControlName="ec" class="kendoInput" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.colorCode}}
            </label>
            <input type="text" kendoTextBox formControlName="colorCode" class="kendoInput" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.maxQtyCanBeOrderedAddText}}
            </label>
            <input type="number" kendoTextBox formControlName="maxQty" class="kendoInput" />
            <span class="k-icon k-i-info" kendoTooltip [title]="finishSampleLbl.infoMaxQuantityText"></span>
          </div>
          <!--<div class="form-group">
    <label class="lblCls">
      {{finishSampleLbl.skulbl}}<span class="requiredField">*</span>
    </label>
    <input type="number" kendoTextBox formControlName="sku" class="kendoInput"
           [ngClass]="{'borderRed':finishSampleLbl.isEmptysku && finishSampleLbl.isSubmitted}"
           (blur)="validateSubCategoryForm()" />
  </div>-->

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.stockNumAddText}}<span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox formControlName="stockNum" class="kendoInput"
                   [ngClass]="{'borderRed':finishSampleLbl.isEmptyStockNum && finishSampleLbl.isSubmitted}"
                   (blur)="validateSubCategoryForm()" />
          </div>

          <div class="form-group" [ngClass]="{'div-sample-cost-history': !isAddHideColumns}">
            <div [ngClass]="{'div-sample-cost-history-textbox': !isAddHideColumns}">
              <label class="lblCls">
                {{finishSampleLbl.currentCostId}}<span class="requiredField" style="margin-right: 10px;">*</span>
              </label>
              <input type="number" kendoTextBox formControlName="currentCostId" class="kendoInput"
                     [ngClass]="{'borderRed':finishSampleLbl.isEmptyCurrentCostId && finishSampleLbl.isSubmitted}"
                     (blur)="validateSubCategoryForm()" />
            </div>
            <div *ngIf="!isAddHideColumns">
              <label class="lblCls" for="foo"></label>
              <kendo-switch formControlName="isCostHistory" [onLabel]="'Hide Cost History'" [offLabel]="'Show Cost History'"
                            class="activeSwitchCls sample-subcategory-cost-switch" (valueChange)="isValidateCostSwitch()">
              </kendo-switch>              
            </div>
          </div>
          <div class="form-group" *ngIf="isSampleSubCategoyCost">
            <kendo-grid [data]="costHeaderGridData"
                        class="costSelectionGridCls"
                        [sortable]="true"
                        [selectable]="false"
                        [navigable]="true"
                        [filterable]="true"
                        [groupable]="false"
                        [reorderable]="true"
                        [resizable]="true"
                        [sort]="costGridstate.sort"
                        [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
                        [pageSize]="costGridstate.take"
                        [skip]="costGridstate.skip"
                        [columnMenu]="{ filter: false, sort: false }"
                        (sort)="costHeaderGridSortChange($event)"
                        (pageChange)="costHeaderGridPageChange($event)"
                        (columnReorder)="onReorder($event)"
                        (columnVisibilityChange)="onVisibilityChange($event)"
                        (dataStateChange)="costHeaderGridDataStateChange($event)"
                        [filter]="costGridSettings.state.filter"
                        [loading]="costLoading">

              
              <kendo-grid-column *ngFor="let col of costGridSettings.columnsConfig"
                                 [field]="col.field"
                                 [title]="col.title"
                                 [width]="col._width"
                                 [filter]="col.filter"
                                 [filterable]="col.filterable"
                                 [hidden]="col.hidden"
                                 [format]="col.format" [headerClass]="'wrapheader-sample-admin-grid'" media="(min-width: 1025px)">

                <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'cost'">
                  {{dataItem.cost | currency}}
                  <kendo-filter-contains-operator></kendo-filter-contains-operator>
                </ng-template>
                
              </kendo-grid-column>

              <ng-template kendoGridNoRecordsTemplate>
              </ng-template>

            </kendo-grid>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.stockingLevel}}<span class="requiredField">*</span>
            </label>
            <input type="number" kendoTextBox formControlName="stockingLevel" class="kendoInput"
                   [ngClass]="{'borderRed':finishSampleLbl.isEmptyStockingLevel && finishSampleLbl.isSubmitted}"
                   (blur)="validateSubCategoryForm()" />
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.dimensions}}
            </label>
          </div>
          <div class="form-group grid-dimension-container">
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.height}}</label>
              <input type="number" kendoTextBox formControlName="height" class="kendoInput" />
            </div>
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.width}}</label>
              <input type="number" kendoTextBox formControlName="width" class="kendoInput" />
            </div>
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.length}}</label>
              <input type="number" kendoTextBox formControlName="length" class="kendoInput" />
            </div>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.weight}}
            </label>
            <input type="number" kendoTextBox formControlName="weight" class="kendoInput" />
          </div>
          <div class="form-group grid-inventory-container" *ngIf="isEditHideColumns">
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.currentInventoryAddText}}<span class="requiredField">*</span></label>
              <input type="number" kendoTextBox formControlName="currentInventory" class="kendoInput txt-current-inventory-readonly" [readonly]="isEditHideColumns"
                     [ngClass]="{'borderRed':finishSampleLbl.isEmptyCurrentInventory && finishSampleLbl.isSubmitted}"
                     (blur)="validateSubCategoryForm();" />
            </div>
            <div *ngIf="!isAddHideColumns">
              <label class="lblCls" for="foo">{{finishSampleLbl.resetTo}}</label>
              <input type="number" kendoTextBox formControlName="resetTo" class="kendoInput" />
            </div>
            <div *ngIf="!isAddHideColumns">
              <label class="lblCls" for="foo">{{finishSampleLbl.adjustment}}</label>
              <input type="number" kendoTextBox formControlName="adjustment" class="kendoInput" />
            </div>
            <div *ngIf="!isAddHideColumns">
              <label class="lblCls" for="foo"></label>
              <button kendoButton [disabled]="subCategorySaveInProcess" class="m-3 btn k-button dialogBtnSize btn-inventory-update" (click)="updateInventorySampleSubCategory()">
                {{finishSampleLbl.updateAction}} <kendo-loader *ngIf="subCategorySaveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
          <div *ngIf="!isEditHideColumns" class="form-group">
            <div>
              <label class="lblCls" for="foo">{{finishSampleLbl.currentInventoryAddText}}<span class="requiredField">*</span></label>
              <input type="number" kendoTextBox formControlName="currentInventory" class="kendoInput"
                     [ngClass]="{'borderRed':finishSampleLbl.isEmptyCurrentInventory && finishSampleLbl.isSubmitted}"
                     (blur)="validateSubCategoryForm();validateSubCategoryOnBackOrder()" />
            </div>
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.reorderPoint}}<span class="requiredField">*</span>
            </label>
            <input type="number" kendoTextBox formControlName="reorderPoint" class="kendoInput"
                   [ngClass]="{'borderRed':finishSampleLbl.isEmptyReorderPoint && finishSampleLbl.isSubmitted}"
                   (blur)="validateSubCategoryForm()" />
          </div>

          <div class="section">
            <label class="k-radio-label" for="foo">Input RGB Colors</label>
            <input type="radio" id="foo" kendoRadioButton (click)="toggleInputRGB()" [checked]="inputRGB" />
            <div class="row rgbClass" *ngIf="inputRGB">
              <div class="col-sm-4">
                <span>R</span><input type="text" kendoTextBox formControlName="inputR" class="kendoInput" />
              </div>
              <div class="col-sm-4">
                <span>G</span><input type="text" kendoTextBox formControlName="inputG" class="kendoInput" />
              </div>
              <div class="col-sm-4">
                <span>B</span><input type="text" kendoTextBox formControlName="inputB" class="kendoInput" />
              </div>
            </div>
            <div class="section uploaded-add-preview-image">
              <div *ngIf="inputRGB">
                <div *ngIf="finishSampleForm.controls['inputR'].value && finishSampleForm.controls['inputG'].value && finishSampleForm.controls['inputB'].value">
                  <div style="width:100px; height:70px;" style.background-color="rgb({{finishSampleForm.controls['inputR'].value}}, {{finishSampleForm.controls['inputG'].value}}, {{finishSampleForm.controls['inputB'].value}})"></div>
                </div>
              </div>
            </div>
            <div class="wrap">
              <kendo-label class="k-radio-label" [for]="barURL" text="Input the URL for image download"></kendo-label>
              <input type="radio" #barURL kendoRadioButton (click)="toggleInputURL()" [checked]="inputURL" />
            </div>
            <div class="form-group" *ngIf="inputURL">
              <input type="text" kendoTextBox formControlName="inputURL" class="kendoInput" />
            </div>
            <div class="section uploaded-add-preview-image">              
              <div *ngIf="inputURL">
                <div *ngIf="finishSampleForm.controls['inputURL'].value">
                  <img src="{{finishSampleForm.controls['inputURL'].value}}" alt="" width="100" height="70" />
                </div>
              </div>
            </div>
            <div class="wrap">
              <kendo-label class="k-radio-label" [for]="bar" text="Upload image"></kendo-label>
              <input type="radio" #bar kendoRadioButton (click)="toggleUploadImage()" [checked]="uploadImage" />
            </div>
            <div class="form-group" *ngIf="uploadImage">
              <label class="lblCls">
                {{finishSampleLbl.fileupload}}
                <!--<span class="requiredField">*</span>-->
              </label>
              <!--<input type="file" formControlName="fileUpload" class="k-button btn kendoInput" name="fileupload"
    (change)="handleFileInput($event.target.files)"
    [ngClass]="{'borderRed':finishSampleLbl.isEmptyFileUpload && finishSampleLbl.isSubmitted}"
    (blur)="validateSubCategoryForm()" />-->
              <div class="kendoInput">
                <app-upload [multiple]="false" (fileSelect)="sampleRequestImageSelected($event)" [uploadFolderPath]="'SampleRequestProduct\\ProductImages'"
                            (uploadSuccess)="sampleRequestUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
              </div>
              <!--<input type="text" kendoTextBox formControlName="fileUrlPath" class="kendoInput" />-->
              <label class="lblCls">
                {{filePath}}
              </label>
            </div>
            <div class="section uploaded-add-preview-image">
              <div *ngIf="uploadImage">
                <div *ngIf="subCategoryFileUpload">
                  <img src="{{imageUrl}}/{{subCategoryFileUpload}}" alt="" width="100" height="70">
                </div>
              </div>
            </div>

          </div>         

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.isActive}}
            </label>
            <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls">
            </kendo-switch>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.onBackOrder}}
            </label>
            <kendo-switch formControlName="isOnBackOrder" [onLabel]="'Yes'" [offLabel]="'No'" [ngStyle]="{'pointer-events': 'none','opacity': '0.6'}" 
                          class="activeSwitchCls">
            </kendo-switch> 
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.isExternal}}
            </label>
            <kendo-switch formControlName="isExternal" [onLabel]="'Yes'" [offLabel]="'No'"  [ngStyle]="isDisableExternal==true ? {'pointer-events': 'none','opacity': '0.6'} : {}" 
                          class="activeSwitchCls">
            </kendo-switch>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.isPDM}}
            </label>
            <kendo-switch formControlName="isPDM" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls" (valueChange)="validateSubCategoryIsExternal()">
            </kendo-switch>
          </div>


        </div>

      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="subCategorySaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="toggleFinishSampleDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="subCategorySaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="saveSampleRequestSubCategory()">
                Save<kendo-loader *ngIf="subCategorySaveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>
<!--Sample Product Fullfilment-->

<section class="dialogSection">
  <kendo-dialog [title]="sampleCategoryTitleText" *ngIf="finishCategoryDialog.opened" (close)="togglefinishCategoryDialog()">
    <form [formGroup]="finishCategoryForm">

      <div class="row">

        <div class="col-sm-12">
          <div class="form-group update-category-note-text" *ngIf="isEditCategoryColumns">
            <span class="lblCls">
              {{finishSampleLbl.infoCategoryText}}
            </span>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.categoryName}}<span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox formControlName="category" class="kendoInput"
                   [ngClass]="{'borderRed':finishSampleLbl.isEmptyCategoryDescription && finishSampleLbl.isSubmitted}"
                   (blur)="validateCategoryForm()" />
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{finishSampleLbl.isActive}}
            </label>
            <kendo-switch formControlName="isCategoryActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls">
            </kendo-switch>
          </div>
        </div>

      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="categorySaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="togglefinishCategoryDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="categorySaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="saveSampleRequestCategory()">
                Save<kendo-loader *ngIf="categorySaveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>

<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.subCategoryDescription }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>



